//NavItem.js
import React, { useState, useEffect, useRef } from "react";
/**
 * Add Escape to close and return focus to the trigger. This helps modal-like menus behave predictably.
 *
 * @param {*} props
 * @return {*}
 */
const NavItem = (props) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown container

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  useEffect(() => {
    if (!open) return; //Only attach global listeners while the menu is open. Avoids performance leaks
    const handleClickOutside = (event) => {
      // If the dropdown is open and the click is outside the dropdownRef, close it
      if (
        open &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    // Add event listener when the component mounts and the dropdown is open
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component unmounts or the dropdown closes
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]); // Rerun the effect when the 'open' state changes

  return (
    <li className="nav-item" ref={dropdownRef}>
      {" "}
      {/* Attach the ref to the dropdown container */}
      <button
        className="nav-button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls="app-menu"
        onClick={() => setOpen(!open)}
      >
        {props.icon}
      </button>
      {open &&
        React.Children.map(props.children, (child) =>
          React.cloneElement(child, { open: open, setOpen: setOpen })
        )}
    </li>
  );
};

export default NavItem;
